import Immutable from 'seamless-immutable';
// --- external imports -----

import {
	JOB_TYPES,
	EMPLOYEES_WORK_STATUS,
} from '~/lib/constants';
// --- internal imports -----

import * as types from './actionTypes';
// --- local imports -----

const initialState = Immutable({
	allEmployees: [],
	rawHiredEmployees: [],
	hiredEmployees: [],
	candidateEmployees: [],
	hiredEmployeesLastUpdate: Date.now(),
	shouldJobTypeFunctionAutomatically: {
		[JOB_TYPES.NEGOTIATOR]: false,
		[JOB_TYPES.SALESMAN]: false
	},
	employeeWorkStatus: {
		[JOB_TYPES.NEGOTIATOR]: EMPLOYEES_WORK_STATUS.IDLE,
		[JOB_TYPES.SALESMAN]: EMPLOYEES_WORK_STATUS.IDLE,
	},
	canStartWorkWithViewingCustomers: false
});

export default function reduce(state = initialState, action = {}) {
	switch (action.type) {
	case types.EMPLOYEES_ENABLE_AUTO_FUNCTIONING:
		return state.merge({
			shouldJobTypeFunctionAutomatically: {
				[action.jobType]: true
			}
		}, {deep: true});
	case types.EMPLOYEES_LOAD_AUTOMATED:
		return state.merge({
			shouldJobTypeFunctionAutomatically: action.automatedEmployees
		});
	case types.EMPLOYEES_HIRE:
	case types.EMPLOYEES_FIRE:
	case types.EMPLOYEES_UPDATE_HIRED_EMPLOYEES:
		let mergeState = {
			hiredEmployees: action.hiredEmployees,
			candidateEmployees: action.candidateEmployees,
			hiredEmployeesLastUpdate: Date.now()
		};

		if (action.rawHiredEmployees) {
			mergeState.rawHiredEmployees = action.rawHiredEmployees;
		}

		return state.merge(mergeState);
	case types.EMPLOYEES_UPDATE_WORK_STATUS_IN_PROGRESS:
	case types.EMPLOYEES_UPDATE_WORK_STATUS_DONE:
		return state.merge({
			employeeWorkStatus: {
				...state.employeeWorkStatus,
				[action.jobType]: action.workStatus
			}
		}, {deep:true}); 
	case types.EMPLOYEES_RESET_WORK_STATUS:
		return state.merge({
			employeeWorkStatus: {
				[JOB_TYPES.NEGOTIATOR]: EMPLOYEES_WORK_STATUS.IDLE,
				[JOB_TYPES.SALESMAN]: EMPLOYEES_WORK_STATUS.IDLE,
			}
		}); 
	case types.EMPLOYEES_UPDATE_ALL_EMPLOYEES:
		return state.merge({
			allEmployees: action.value,
			// eslint-disable-next-line camelcase
			is_loaded: true
		});
	case types.EMPLOYEES_UPDATE_CAN_WORK_WITH_VIEWING_CUSTOMERS:
		return state.merge({
			canStartWorkWithViewingCustomers: action.canStartWork
		});
	default:
		return state;
	}
}
